import SpecialShowcase from "@/pages/home/components/SpecialShowcase";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { usePageMeta } from "@/hooks/usePageMeta";
import { specials } from "@/mocks/specials";

export default function SpecialPage() {
  usePageMeta({
    title: "影视专题合集 - 主题片单推荐 - 妻子的朋友",
    description:
      "妻子的朋友策划了多个影视专题合集，从悬疑刑侦到治愈生活，按主题成体系地为你推荐好作品。",
    keywords: "影视专题,主题片单,影视推荐,片单合集,妻子的朋友",
  });

  const totalWorks = specials.reduce(
    (sum, sp) => sum + sp.groups.reduce((s, g) => s + g.workIds.length, 0),
    0
  );

  return (
    <div className="mx-auto w-full max-w-[1360px] px-4 py-8 md:px-6 md:py-10">
      <Breadcrumb items={[{ label: "专题合集" }]} />

      <header className="mt-4 overflow-hidden rounded-lg border border-background-200 bg-primary-900 p-6 md:p-8">
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider text-accent-300 uppercase">
          <span className="h-3 w-1 rounded-full bg-accent-500"></span>
          策划专题
        </span>
        <h1 className="mt-2 font-heading text-3xl font-bold text-background-50 md:text-4xl">
          影视专题合集
        </h1>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-primary-100">
          我们以主题为单位整理片单：同一类气氛、同一种情绪、同一段人生况味。
          比起漫无目的地翻找，按专题浏览能帮你更快找到此刻想看的作品。
        </p>
        <div className="mt-5 flex flex-wrap gap-6">
          <div>
            <div className="font-heading text-2xl font-black text-background-50">
              {specials.length}
            </div>
            <div className="text-xs text-primary-200">策划专题</div>
          </div>
          <div>
            <div className="font-heading text-2xl font-black text-background-50">{totalWorks}</div>
            <div className="text-xs text-primary-200">专题收录作品</div>
          </div>
        </div>
      </header>

      <section className="mt-8">
        <SpecialShowcase />
      </section>
    </div>
  );
}